import { useEffect, useState } from "react";
import { NavLink, useParams } from "react-router-dom";
import { fetchBlogPostBySlug } from '../api/blogApi';
import { usePublicContent } from '../context/PublicContent';

export default function BlogPost() {
  const { slug } = useParams();
  const { post: initialPost } = usePublicContent();
  const [loadedPost, setPost] = useState(null);
  const post = loadedPost?.slug === slug ? loadedPost : initialPost?.slug === slug ? initialPost : null;
  const [err, setErr] = useState("");

  useEffect(() => {
    if (post?.slug === slug) return undefined;
    let active = true;
    setErr('');
    (async () => {
      try {
        const data = await fetchBlogPostBySlug(slug);
        if (active) setPost(data);
      } catch (e) {
        if (active) setErr(String(e?.message || e));
      }
    })();
    return () => { active = false; };
  }, [slug, post?.slug]);

  if (err) return <section className="mx-auto max-w-3xl px-6 py-10"><h1 className="text-3xl font-bold">Article unavailable</h1><p className="mt-4">Read the archive on <a href="https://blog.angeloruiz.com" className="text-indigo-600 underline">the WordPress blog</a> or return to <a href="/blog" className="text-indigo-600 underline">all articles</a>.</p></section>;
  if (!post) return <section className="p-10"><h1 className="text-3xl font-bold">Loading article</h1><p className="mt-4">You can also read articles on <a href="https://blog.angeloruiz.com">the WordPress blog</a>.</p></section>;

  const cover = post.coverImage || { url: '', alt: '' };

  return (
    <article className="max-w-3xl mx-auto px-6 py-10">
      <NavLink to="/blog" className="text-sm text-indigo-600 hover:underline mb-6 inline-block">
        ← Back to Blog
      </NavLink>
      {/* Featured image (with graceful fallback) */}
      {cover.url && (
        <img
          src={cover.url}
          alt={cover.alt || `Illustration for ${post.title || slug}`}
          width="768"
          height="432"
          className="w-full aspect-[16/9] object-cover rounded-2xl mb-8 shadow-sm"
          loading="eager"
        />
      )}

      {/* Title + date */}
      <h1
        className="text-3xl font-bold mb-2"
        dangerouslySetInnerHTML={{ __html: post.titleHtml || "" }}
      />
      <div className="text-sm opacity-70 mb-6">
        {post.date ? post.date.slice(0, 10) : ""}
      </div>

      {/* WP HTML body */}
      <div
        className="wp-content prose prose-lg max-w-none"
        dangerouslySetInnerHTML={{ __html: post.contentHtml || "" }}
      />
    </article>
  );
}
